import request from '@/util/request'

export function getAllCategory(query) {
  return request({
    url: '/product/category',
    method: 'get',
    params: query,
  })
}

export function listProducts(query) {
  return request({
    url: '/product/list',
    method: 'get',
    params: query,
  })
}

export function getProductInfo(query) {
  return request({
    url: '/product/info',
    method: 'get',
    params: query,
  })
}
